import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

const MissingFormMessage = ({ adsConfirmed, className = '' }) => {
  const data = useStaticQuery(graphql`
    query MessagesQuery {
      settings: contentfulSiteSettings(contentful_id: { eq: "3vxKUCou9H8hWkqL5dcaNm" }) {
        formAdBlockFailureMessage {
          raw
        }
        formLoadFailureMessage {
          raw
        }
      }
    }
  `);

  if (adsConfirmed) {
    return (
      <div className={className}>
        {documentToReactComponents(JSON.parse(get(data, 'settings.formAdBlockFailureMessage.raw')))}
      </div>
    );
  }

  return (
    <div className={className}>
      {documentToReactComponents(JSON.parse(get(data, 'settings.formLoadFailureMessage.raw')))}
    </div>
  );
};

class AdTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      adBlockDetected: false,
      tested: false,
    };
    this.testAds = this.testAds.bind(this);
  }

  componentDidMount() {
    this.testAds();
  }

  async testAds() {
    if (this.state.tested) {
      return;
    }
    await this.setState({ tested: true });

    // try {
    //   await fetch(
    //     new Request('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
    //       method: 'HEAD',
    //       mode: 'no-cors',
    //     })
    //   );
    // } catch (err) {
    //   if (typeof window !== 'undefined' && !!window.FS) {
    //     window.FS.event('Marketo Form', { type: 'Likely ad blocker used', formID: this.props.formId.toString() });
    //   }
    //   this.setState({ adBlockDetected: true });
    // }
  }

  render() {
    if (this.props.formLoadFailed) {
      return <MissingFormMessage className={this.props.className} adsConfirmed={this.state.adBlockDetected} />;
    }
    return null;
  }
}

AdTest.propTypes = {
  formLoadFailed: PropTypes.bool.isRequired,
  formId: PropTypes.number,
};

export default AdTest;
